<template>
  <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12 px-2" style="margin-top: 15px">
    <div class="bg-white rounded shade mt-2 mb-4">
      <div class="d-flex align-items-center flex-wrap">
        <div class="p-t-5 pl-3 p-b-5 mr-3">
          <!-- Page Title -->
          <h3 style="font-size: 20px">
            <a v-if="backTo" @click.prevent="goBack" href="#">
              <i class="bi bi-arrow-left" />
            </a>
            <i v-if="icon" :class="icon" />
            {{ title }}
            <span v-if="is_sna" class="ml-1">
              <i class="bi bi-question-circle text-blue" v-tooltip.right="{ ref: 'snaHelper' }" />
              <div ref="snaHelper" class="tooltip-content">
                <p>
                  <b>Social Network Analytic (SNA)</b>. Berita yang terdapat
                  pada halaman ini hanya bersumber dari Twitter dan Retweet oleh user lainnya
                </p>
              </div>
            </span>
            <i v-if="tooltip" class="bi bi-question-circle text-blue" v-tooltip.right="{ ref: 'pageHeaderHelper' }" />
          </h3>
          <!-- Tooptip Bantuan -->
          <div v-if="tooltip" ref="pageHeaderHelper" class="tooltip-content" v-html="tooltip" />
        </div>
        <!-- Filter Component -->
        <div v-if="hideFilter === false" class="padding-15 ml-auto" style="max-width: 100%;">
          <div class="d-flex align-items-center">
            <!-- Filter Tanggal -->
            <div id="reportrange" class="ml-auto mr-2" style="
                background: #fff;
                cursor: pointer;
                padding: 5px 10px;
                box-shadow: rgba(184, 192, 202, 0.5) 0px 0px 3px !important;
                width: max-content;
                height: 40.5px;
                padding-top: 10px;
                border-radius: 5px;
                min-width: 300px;
              ">
              <i class="bi bi-calendar2-week m-r-15" />&nbsp; <span />
              <i class="bi bi-caret-down-fill" style="
                  margin-left: 5px !important;
                  color: rgb(155, 156, 156) !important;
                  font-size: 10px !important;
                " />
            </div>
            <!-- Filter Cakupan -->
            <!-- <div
            v-if="!hideCakupan"
            class="input-group mr-2"
            id="page-header-cakupan"
            style="width: max-content !important"
          >
            <multiselect
              v-model="cakupan"
              :options="cakupan_options"
              :searchable="true"
              :allowEmpty="false"
              @input="changeCakupan"
              placeholder="Pilih Cakupan"
            >
            </multiselect>
          </div> -->
            <!-- Filter Validasi -->
            <div v-if="!hideValidate" class="input-group mr-2" id="page-header-validasi"
              style="width: max-content !important">
              <multiselect v-model="is_validated" :options="validate_options" :searchable="true" :allow-empty="false"
                @input="changeValidate" placeholder="Pilih Data" />
            </div>
            <!-- Filter Group -->
            <div v-if="display_tipe != 1 && topik && !hideTopik && !is_sna" class="input-group mr-2"
              id="page-header-group" style="width: max-content !important">
              <!-- <multiselect ref="multiselect" v-if="topics" v-model="selectedGroup" :options="group_options"
                :searchable="true" :allow-empty="false" group-values="children" group-label="text"
                placeholder="Pilih Grup" @input="groupChanged" @select="changeSelectedGroup" label="text"
                track-by="text">
                <template slot="singleLabel" slot-scope="props">
                  <span v-if="props.option.text.length > 10" style="font-size: 14px !important">
                    {{ props.option.text.substring(0, 10) }}...
                  </span>
                  <span v-else style="font-size: 14px !important">
                    {{ props.option.text }}
                  </span>
                </template>
              </multiselect> -->
            </div>

            <!-- Filter Topik Online -->
            <div v-if="topik && !hideTopik && (isType == 'medkon' || isType == null)" class="input-group mr-2"
              id="page-header-select" style="width: max-content; min-width: 200px;">
              <multiselect ref="multiselect" v-if="topics" v-model="selectedTopic" :options="topic_options"
                group-values="children" group-label="text" :multiple="true" :searchable="true" :limit="1"
                :limit-text="limitText" :close-on-select="false" :allow-empty="true"
                placeholder="Pilih Topik Media Online" @input="checkTopicChanged" label="text" track-by="text"
                :custom-label="customLabel" :internal-search="false" @select="toggleMultiselect('open')"
                @open="toggleMultiselect('open')" @close="toggleMultiselect('close')" @remove="removeOption"
                @search-change="searchValue">
                <!-- Custom Option Topik -->
                <template slot="option" slot-scope="props">
                  <span>
                    <span v-if="props.option.text" :class="props.option.category == 'medkon'
                      ? 'bg-success px-1'
                      : props.option.category == 'medon'
                        ? 'bg-danger px-1'
                        : ''
                      " class="rounded">
                      <i class="bi bi-globe-americas" style="color: white !important; font-size: 15px"
                        v-if="props.option.category == 'medkon'" />
                      <i class="bi bi-heart-fill" style="color: white !important; font-size: 15px"
                        v-else-if="props.option.category == 'medon'" />
                    </span>
                    {{ props.option.$groupLabel || props.option.text }}
                  </span>
                </template>
                <!-- Custom Batas Topik Dipilih -->
                <template slot="limit">
                  <span class="multiselect__strong" v-show="!is_open">
                    dan
                    {{
                      Array.isArray(selectedTopic)
                        ? selectedTopic.length - 1
                        : 0
                    }}
                    lainnya
                  </span>
                </template>
              </multiselect>
            </div>
            <!-- Filter Topik Online -->

            <!-- Filter Topik Sosial -->
            <div v-if="topik && !hideTopik && (isType == 'medsos' || isType == null)" class="input-group"
              id="page-header-select" style="width: max-content; min-width: 200px;">
              <multiselect ref="multiselect" v-if="topics" v-model="selectedTopic_sna" :options="topic_options_sna"
                group-values="children" group-label="text" :multiple="true" :searchable="true" :limit="1"
                :limit-text="limitText" :close-on-select="false" :allow-empty="true"
                placeholder="Pilih Topik Media Sosial" @input="checkTopicChanged" label="text" track-by="text"
                :custom-label="customLabel" :internal-search="false" @select="toggleMultiselect('open')"
                @open="toggleMultiselect('open')" @close="toggleMultiselect('close')" @remove="removeOption_sna"
                @search-change="searchValue_sna">
                <!-- Custom Option Topik -->
                <template slot="option" slot-scope="props">
                  <span>
                    <span v-if="props.option.text" :class="props.option.category == 'medkon'
                      ? 'bg-success px-1'
                      : props.option.category == 'medon'
                        ? 'bg-danger px-1'
                        : ''
                      " class="rounded">
                      <i class="bi bi-globe-americas" style="color: white !important; font-size: 15px"
                        v-if="props.option.category == 'medkon'" />
                      <i class="bi bi-heart-fill" style="color: white !important; font-size: 15px"
                        v-else-if="props.option.category == 'medon'" />
                    </span>
                    {{ props.option.$groupLabel || props.option.text }}
                  </span>
                </template>
                <!-- Custom Batas Topik Dipilih -->
                <template slot="limit">
                  <span class="multiselect__strong" v-show="!is_open">
                    dan
                    {{
                      Array.isArray(selectedTopic_sna)
                        ? selectedTopic_sna.length - 1
                        : 0
                    }}
                    lainnya
                  </span>
                </template>
              </multiselect>
            </div>
            <!-- Filter Topik Sosial -->


            <!-- Tombol Reset Filter Topik dan Group -->
            <button
              v-if="!!((selectedTopic && selectedTopic.length > 0 && is_set_topic) || (selectedTopic_sna && selectedTopic_sna.length > 0 && is_set_topic_sna))"
              class="btn btn-danger btn-lg px-0 ml-1" style="height: 40.5px; border-radius: 5px" @click="clearTopic">
              <i class="bi bi-trash" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import moment from "moment";
import "bootstrap-daterangepicker/daterangepicker.js";
import Multiselect from "vue-multiselect";

export default {
  name: "PageHeader",
  props: {
    icon: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    hideFilter: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    hideTopik: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    hideValidate: {
      type: Boolean,
      default: function () {
        return true;
      },
    },
    hideCakupan: {
      type: Boolean,
      default: function () {
        return true;
      },
    },
    tooltip: {
      type: String,
      default: "",
    },
    backTo: {
      type: Boolean,
      default: false,
    },
    topics: {
      type: Object,
      default: () => {
        return {};
      },
    },
    topics_sna: {
      type: Object,
      default: () => {
        return {};
      },
    },
    topik: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
    isType: {
      type: String,
      default: () => {
        return null;
      },
    },
    is_sna: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  components: {
    Multiselect,
  },
  data() {
    return {
      initial_topic_options: [],
      topic_options: [],
      topic_temp_opt: [],
      group_options: [],
      is_validated: "Semua Data",
      cakupan: "Semua Cakupan",
      selectedTopic: null,
      selectedGroup: null,
      err: null,
      id_project: this.$store.getters.user.id_project,
      start: "",
      end: "",
      filter_change: 0,
      isChange: false,
      display_tipe:
        this.$store.getters.user.project.project_detail.display_tipe,
      is_open: false,
      is_set_topic: false,
      validate_options: ["Semua Data", "Tervalidasi", "Belum Tervalidasi"],
      cakupan_options: ["Semua Cakupan", "Internasional"],

      // topik untuk sna
      initial_topic_options_sna: [],
      topic_options_sna: [],
      topic_temp_opt_sna: [],
      is_set_topic_sna: false,
      filter_change_sna: 0,
      selectedTopic_sna: null,
      // group_options: [],
      // is_validated: "Semua Data",
      // cakupan: "Semua Cakupan",
      // selectedGroup: null,
      // err: null,
      // id_project: this.$store.getters.user.id_project,
      // start: "",
      // end: "",
      // isChange: false,
      // display_tipe:
      //   this.$store.getters.user.project.project_detail.display_tipe,
      // is_open: false,
      // validate_options: ["Semua Data", "Tervalidasi", "Belum Tervalidasi"],
      // cakupan_options: ["Semua Cakupan", "Internasional"],
    };
  },
  methods: {
    searchValue: function (query) {
      const options = JSON.parse(JSON.stringify(this.topic_temp_opt));
      const hasilFilter = options
        .map((item) => ({
          ...item,
          children: item.children.filter((child) =>
            child.text.toLowerCase().trim().includes(query.toLowerCase().trim())
          ),
        }))
        .filter((item) => item.children.length > 0);
      this.topic_options = hasilFilter;
    },
    searchValue_sna: function (query) {
      const options = JSON.parse(JSON.stringify(this.topic_temp_opt_sna));
      const hasilFilter = options
        .map((item) => ({
          ...item,
          children: item.children.filter((child) =>
            child.text.toLowerCase().trim().includes(query.toLowerCase().trim())
          ),
        }))
        .filter((item) => item.children.length > 0);
      this.topic_options_sna = hasilFilter;
    },
    customLabel: function (option) {
      return option.text;
    },
    removeOption: function (val) {
      const temp = this.selectedTopic.filter((el) => el.id != val.id);
      this.selectedTopic = temp;
      this.changeSelectedTopic();
    },
    removeOption_sna: function (val) {
      const temp = this.selectedTopic_sna.filter((el) => el.id != val.id);
      this.selectedTopic_sna = temp;
      this.changeSelectedTopic();
    },
    toggleMultiselect: function (type) {
      if (type == "open") {
        this.is_open = true;
      } else {
        this.is_open = false;
      }
      const labelElements = document.getElementsByClassName(
        "multiselect__tags-wrap"
      );
      const textLimitElements = document.getElementsByClassName(
        "multiselect__strong"
      );

      for (let i = 0; i < labelElements.length; i++) {
        if (type == "open") {
          labelElements[i].style.display = "none";
        } else {
          labelElements[i].style.display = "inline";
        }
      }

      for (let i = 0; i < textLimitElements.length; i++) {
        if (type == "open") {
          textLimitElements[i].style.display = "none";
        } else {
          textLimitElements[i].style.display = "inline";
        }
      }
    },
    limitText: function (count) {
      return `dan ${count} Lainnya`;
    },
    changeSelectedGroup: function (val) {
      this.selectedTopic = [{ id: "all", text: "Pilih Topik Media Online" }];
      this.deleteParam("topic_selected");
      let data = {
        from: this.start,
        to: this.end,
      };
      if (val.id == "all") {
        this.deleteParam("group");
      } else {
        data.group = val.id;
        this.updateUrlQuery("group", val.id);
      }
      this.$store.dispatch("set_topic_filter", this.selectedTopic);
      this.$store.dispatch("set_topic_filter_sna", this.selectedTopic_sna);
      this.$store.dispatch("set_group_filter", val);
      this.$emit("filterChange", data);
    },
    changeSelectedTopic: function () {
      if (this.selectedTopic.length > 0 || this.selectedTopic_sna.length != 0) {
        this.deleteParam("group");
        let data = {
          from: this.start,
          to: this.end,
        };
        let groupCondition = this.selectedTopic.id == "all" ||
          this.selectedTopic.find((el) => el.id == "all")
        let checkMedsos = this.selectedTopic_sna.id != "all" ||
          this.selectedTopic.find((el) => el.id != "all")
        // console.log(checkMedsos);
        if (groupCondition && !checkMedsos) {
          // console.log('Dalam If Group')
          const is_group =
            (Array.isArray(this.selectedGroup) &&
              this.selectedGroup[0].id == "all") ||
            this.selectedGroup.id == "all";
          if (!is_group) {
            this.deleteParam("topic_selected");
            data.group = this.selectedGroup.id;
            this.updateUrlQuery("group", this.selectedGroup.id);
          } else {
            this.deleteParam("topic_selected");
          }
        } else {
          // console.log('Kondisi If Group')
          // Ensure selectedTopic and selectedTopic_sna are arrays
          const selectedTopicArray = Array.isArray(this.selectedTopic) ? this.selectedTopic : null;
          const selectedTopicSnaArray = Array.isArray(this.selectedTopic_sna) ? this.selectedTopic_sna : null;

          // Combine selectedTopic and selectedTopic_sna
          var dataCombine
          if (selectedTopicArray && selectedTopicSnaArray) {
            dataCombine = [...selectedTopicArray, ...selectedTopicSnaArray];
          } else {
            dataCombine = selectedTopicArray ? selectedTopicArray : selectedTopicSnaArray;
          }
          // Map the combined array to get the IDs
          const hasAll = dataCombine.some(el => el.id === "all");
          const filteredData = hasAll ? dataCombine.filter(el => el.id !== "all") : dataCombine;
          const temp_data = filteredData.map((el) => el.id);
          // Join the IDs into a single string
          const id_selected = temp_data.join(",");
          // Update the URL query with the base64 encoded IDs
          if (id_selected != "") {
            this.updateUrlQuery("topic_selected", btoa(id_selected));
            // Update data.topic_selected with the base64 encoded IDs
            data.topic_selected = btoa(id_selected);
          } else {
            this.deleteParam("topic_selected");
          }
        }
        this.$store.dispatch("set_topic_filter", this.selectedTopic);
        this.$store.dispatch("set_topic_filter_sna", this.selectedTopic_sna);
        this.$emit("filterChange", data);
      }
    },
    clearTopic: function () {
      this.is_set_topic = false;
      this.is_set_topic_sna = false;
      this.topic_options = this.initial_topic_options;
      this.topic_options_sna = this.initial_topic_options_sna;
      // Add this block to filter the topic options based on the is_type parameter
      this.topic_options_sna = this.topic_options_sna.filter(option =>
        option.children.some(child => child.category === "medon")
      );
      this.topic_options = this.topic_options.filter(option =>
        option.children.some(child => child.category === "medkon")
      );
      this.topic_temp_opt = this.topic_options;
      this.topic_temp_opt_sna = this.topic_options_sna;
      this.selectedTopic = [{ id: "all", text: "Pilih Topik Media Online" }];
      this.selectedTopic_sna = [{ id: "all", text: "Pilih Topik Media Sosial" }];
      this.selectedGroup = { id: "all", text: "Semua Grup" };
      this.is_validated = "Semua Data";
      this.$store.dispatch("set_topic_filter", this.selectedTopic);
      this.$store.dispatch("set_topic_filter_sna", this.selectedTopic_sna);
      this.$store.dispatch("set_group_filter", this.selectedGroup);
      this.$store.dispatch("set_validate_filter", "Semua Data");
      this.deleteParam("topic_selected");
      this.deleteParam("group");
      this.deleteParam("is_validated");
      let data = {
        from: this.start,
        to: this.end,
      };
      this.$emit("filterChange", data);
    },
    checkTopicChanged: function () {
      // Online Media Selected
      if (this.selectedTopic.length > 0) {
        this.is_set_topic = true;
        if (this.selectedTopic[this.selectedTopic.length - 1].id == "all") {
          const temp = this.selectedTopic.filter((el) => el.id == "all");
          this.selectedTopic = temp;
        } else {
          if (
            this.selectedTopic[this.selectedTopic.length - 1].tipe == "group"
          ) {
            const temp = this.selectedTopic.filter((el) => el.tipe == "group");
            this.selectedTopic = temp;
          } else {
            const temp = this.selectedTopic.filter((el) => el.tipe == "topik");
            this.selectedTopic = temp;
          }
        }
      }
      // Social Media Selected
      if (this.selectedTopic_sna.length > 0) {
        this.is_set_topic_sna = true;
        if (this.selectedTopic_sna[this.selectedTopic_sna.length - 1].id == "all") {
          const temp = this.selectedTopic_sna.filter((el) => el.id == "all");
          this.selectedTopic_sna = temp;
        } else {
          const temp = this.selectedTopic_sna.filter((el) => el.tipe == "topik");
          this.selectedTopic_sna = temp;
        }
      }
      this.changeSelectedTopic();
    },
    groupChanged: function (is_changed = true) {
      this.is_set_topic = true;
      if (this.selectedGroup && this.selectedGroup.id == "all") {
        this.topic_options = this.initial_topic_options;
        this.topic_temp_opt = this.topic_options;
        this.topic_options_sna = this.initial_topic_options_sna;
        this.topic_temp_opt_sna = this.topic_options_sna;
      } else {
        if (is_changed) {
          this.selectedTopic = [{ id: "all", text: "Pilih Topik Media Online" }];
          this.selectedTopic_sna = [{ id: "all", text: "Pilih Topik Media Sosial" }];
        } else {
          this.selectedTopic = this.$store.getters.filter_topic
            ? this.$store.getters.filter_topic
            : [{ id: "all", text: "Pilih Topik Media Online" }];
          this.selectedTopic_sna = this.$store.getters.filter_topic_sna
            ? this.$store.getters.filter_topic_sna
            : [{ id: "all", text: "Pilih Topik Media Sosial" }];
        }
        let opt = [];
        opt = JSON.parse(JSON.stringify(this.initial_topic_options));
        let filter_val = opt.filter((el) => el.text == this.selectedGroup.text);
        filter_val.unshift({
          text: "Pilih Topik Media Online",
          children: [
            {
              id: "all",
              text: "Semua Topik",
            },
          ],
        });
        this.topic_options = filter_val;
        this.topic_temp_opt = this.topic_options;
        this.topic_options_sna = [];
        this.topic_temp_opt_sna = this.topic_options_sna;
      }
    },
    loadFilter: function () {
      // console.log(!!((this.selectedTopic && this.selectedTopic.length > 0 && this.is_set_topic) || (this.selectedTopic_sna && this.selectedTopic_sna.length > 0 && this.is_set_topic_sna)));
      // console.log(this.selectedTopic, this.is_set_topic, this.selectedTopic_sna, this.is_set_topic_sna);
      if ("from" in this.$route.query) {
        this.start = moment(this.$route.query.from, "YYYY-MM-DD HH:mm:ss");
      } else {
        if (this.$store.getters.filter_date_from) {
          let dateStart = moment(
            this.$store.getters.filter_date_from,
            "D MMM YYYY"
          );

          this.start = dateStart;
        } else {
          this.start = moment().format("D MMM YYYY 00:00:00");
        }
      }

      if ("to" in this.$route.query) {
        this.end = moment(this.$route.query.to, "YYYY-MM-DD HH:mm:ss");
      } else {
        if (this.$store.getters.filter_date_to) {
          let dateEnd = moment(
            this.$store.getters.filter_date_to,
            "D MMM YYYY"
          );

          this.end = dateEnd;
        } else {
          this.end = moment().format("YYYY-MM-DD 23:59:59");
        }
      }

      var dateRange = {};
      dateRange["Hari ini"] = [
        moment().format("D MMM YYYY 00:00:00"),
        moment().format("D MMM YYYY 23:59:59"),
      ];
      dateRange["Kemarin"] = [
        moment().subtract(1, "days").format("D MMM YYYY 00:00:00"),
        moment().subtract(1, "days").format("D MMM YYYY 23:59:59"),
      ];
      dateRange["7 Hari Terakhir"] = [
        moment().subtract(6, "days").format("D MMM YYYY 00:00:00"),
        moment().format("D MMM YYYY 23:59:59"),
      ];
      dateRange["1 Bulan Terakhir"] = [
        moment().subtract(29, "days").format("D MMM YYYY 00:00:00"),
        moment().format("D MMM YYYY 23:59:59"),
      ];
      dateRange["3 Bulan Terakhir"] = [
        moment()
          .subtract(30 * 3 - 1, "days")
          .format("D MMM YYYY 00:00:00"),
        moment().format("D MMM YYYY 23:59:59"),
      ];
      $("#reportrange").daterangepicker(
        {
          timePicker: true,
          timePicker24Hour: true,
          timePickerSeconds: true,
          showDropdowns: true,
          startDate: this.start,
          endDate: this.end,
          ranges: dateRange,
          opens: "center",
          locale: {
            format: "DD MMM YYYY HH:mm:ss",
            applyLabel: "Cari",
            cancelLabel: "Batal",
            monthNames: [
              "Januari",
              "Februari",
              "Maret",
              "April",
              "Mei",
              "Juni",
              "Juli",
              "Agustus",
              "September",
              "Oktober",
              "November",
              "Desember",
            ],
          },
        },
        this.changeDate
      );

      return this.changeDate(this.start, this.end, "default");
    },
    changeDate: function (start, end, def_value) {
      let filter_date_start = null;
      let filter_date_to = null;
      let from = "";
      let to = "";
      if (def_value == "default") {
        from = start.locale("id").format("YYYY-MM-DD HH:mm:ss");
        to = end.locale("id").format("YYYY-MM-DD HH:mm:ss");
        $("#reportrange span").html(
          start.format("D MMM YYYY HH:mm") +
          " - " +
          end.format("D MMM YYYY HH:mm")
        );
      } else {
        from = start.locale("id").format("YYYY-MM-DD HH:mm:ss");
        to = end.locale("id").format("YYYY-MM-DD HH:mm:ss");
        $("#reportrange span").html(
          start.format("D MMM YYYY HH:mm:ss") +
          " - " +
          end.format("D MMM YYYY HH:mm:ss")
        );
      }
      filter_date_start = from;
      filter_date_to = to;
      let date_param = {
        from: filter_date_start,
        to: filter_date_to,
      };
      this.start = start;
      this.end = end;
      let filter_date = {
        from: start,
        to: end,
      };
      if (def_value != "default") {
        this.updateUrlQueryMany(date_param);
        this.$store.dispatch("set_date_filter", filter_date);
        let data = {
          from: this.start,
          to: this.end,
          topic_selected: this.selectedTopic.id + this.selectedTopic_sna.id,
        };
        this.$emit("filterChange", data);
      } else {
        this.$store.dispatch("set_date_filter", filter_date);
        return date_param;
      }
    },
    updateUrlQuery: function (key, value) {
      if (!this.hideFilter) {
        let queries = JSON.parse(JSON.stringify(this.$route.query));
        queries[key] = value;
        if ("page" in this.$route.query) {
          queries.page = 1;
        }
        if (this.$.param(this.$route.query) != this.$.param(queries)) {
          this.$router.replace({ query: queries });
        }
      }
    },
    updateUrlQueryMany: function (param) {
      if (!this.hideFilter) {
        let queries = JSON.parse(JSON.stringify(this.$route.query));
        for (let key in param) {
          queries[key] = param[key];
        }
        if ("page" in this.$route.query) {
          queries.page = 1;
        }

        if (this.$.param(this.$route.query) != this.$.param(queries)) {
          this.$router.replace({ query: queries });
        }
      }
    },
    getTopics: function () {
      let self = this;
      let api = process.env.VUE_APP_API_URL + "list-topics/" + this.id_project;
      this.$http
        .get(api)
        .then(function (response) {
          let resp = response.data;
          self.topics = resp;


          let topik = [];
          let topik_formed = [];
          let tpk;

          for (var key in resp.socmed) {
            tpk = {
              id: key,
              text: resp.socmed[key],
              tipe: "topik",
              category: "medon",
            };
            topik.push(tpk);
          }

          for (key in resp.formed) {
            let count_topic = Object.entries(resp.formed[key].topics).length;
            if (key != 0 || count_topic > 0) {
              tpk = {
                id: key,
                text: resp.formed[key].group_name,
                tipe: "group",
                category: "medkon",
              };
              topik_formed.push(tpk);
              for (let index in resp.formed[key].topics) {
                tpk = {
                  id: index,
                  text: "-- " + resp.formed[key].topics[index],
                  tipe: "topik",
                  category: "medkon",
                };
                topik_formed.push(tpk);
              }
            }
          }

          // Handle query parameters for selectedTopic
          if ("topic" in self.$route.query) {
            let q_topic = self.$route.query.topic;
            if (q_topic in self.topics.socmed) {
              self.selectedTopic = {
                id: q_topic,
                text: self.topics.socmed[q_topic],
                tipe: "topik",
                category: "medon",
              };
            } else {
              for (let gr in self.topics.formed) {
                for (let tp in self.topics.formed[gr].topics) {
                  if (tp == q_topic) {
                    self.selectedTopic = {
                      id: q_topic,
                      text: "-- " + self.topics.formed[gr].topics[tp],
                      tipe: "topik",
                      category: "medkon",
                    };
                  }
                }
              }
            }
          } else {
            if ("group" in self.$route.query) {
              let q_group = self.$route.query.group;
              self.selectedTopic = {
                id: q_group,
                text: self.topics.formed[q_group].group_name,
                tipe: "group",
                category: "medkon",
              };
            } else {
              self.selectedTopic = self.$store.getters.filter_topic
                ? self.$store.getters.filter_topic
                : [{ id: "all", text: "Pilih Topik Media Online" }];
              self.selectedTopic_sna = self.$store.getters.filter_topic_sna
                ? self.$store.getters.filter_topic_sna
                : [{ id: "all", text: "Pilih Topik Media Sosial" }];
            }
          }

          // Handle query parameters for selectedTopic_sna
          if ("topic" in self.$route.query) {
            let q_topic = self.$route.query.topic;
            if (q_topic in self.topics.socmed) {
              self.selectedTopic_sna = {
                id: q_topic,
                text: self.topics.socmed[q_topic],
                tipe: "topik",
                category: "medon",
              };
            }
          }

          // Update URL query and Vuex store
          if (self.selectedTopic.id != "all") {
            if (self.selectedTopic.tipe == "topik") {
              self.updateUrlQuery("topic", self.selectedTopic.id);
            } else if (self.selectedTopic.tipe == "group") {
              self.updateUrlQuery("group", self.selectedTopic.id);
            }
          }

          if (self.selectedTopic_sna.id != "all") {
            if (self.selectedTopic_sna.tipe == "topik") {
              self.updateUrlQuery("topic", self.selectedTopic_sna.id);
            } else if (self.selectedTopic_sna.tipe == "group") {
              self.updateUrlQuery("group", self.selectedTopic_sna.id);
            }
          }

          // Prepare group_topic options
          let group_topic = [{
            text: "Pilih Topik Media Online",
            children: [
              {
                id: "all",
                text: "Semua Topik"
              }],
          }];

          if (self.$store.getters.user.project.project_detail.tipe == 1) {
            if (topik_formed.length > 0) {
              group_topic.push({
                text: "Media Online",
                children: topik_formed.filter((el) => el.tipe === "topik"),
                element: HTMLOptGroupElement,
              });
            }
            if (topik.length > 0) {
              group_topic.push({
                text: "Media Sosial",
                children: topik.filter((el) => el.tipe === "topik"),
                element: HTMLOptGroupElement,
              });
            }
          } else {
            group_topic = group_topic.concat(topik);
          }

          self.initial_topic_options = group_topic;
          self.initial_topic_options_sna = group_topic;

          self.$store.dispatch("set_topic_filter", self.selectedTopic);
          self.$store.dispatch("set_topic_filter_sna", self.selectedTopic_sna);
        })
        .catch(function (err) {
          self.err = err.response;
        });
    },
    loadTopic: function () {
      let self = this;
      let resp = self.topics;
      let topik = [];
      let topik_formed = [];
      let tpk;
      let option = [];

      for (var key in resp.socmed) {
        tpk = {
          id: key,
          text: resp.socmed[key],
          tipe: "topik",
          category: "medon",
        };
        topik.push(tpk);
      }

      for (key in resp.formed) {
        let count_topic = Object.entries(resp.formed[key].topics).length;
        if (key != 0 || count_topic > 0) {
          let group = {
            text: resp.formed[key].group_name,
            children: [],
            element: HTMLOptGroupElement,
          };
          tpk = {
            id: key,
            text: resp.formed[key].group_name,
            tipe: "group",
            category: "medkon",
          };
          topik_formed.push(tpk);
          for (let index in resp.formed[key].topics) {
            tpk = {
              id: index,
              text: resp.formed[key].topics[index],
              tipe: "topik",
              group: key,
              category: "medkon",
            };
            group.children.push(tpk);
            topik_formed.push(tpk);
          }
          option.push(group);
        }
      }

      if ("topic_selected" in self.$route.query) {
        // Group
        self.selectedGroup = self.$store.getters.filter_group
          ? self.$store.getters.filter_group
          : { id: "all", text: "Semua Grup" };
        // Online
        self.selectedTopic = self.$store.getters.filter_topic
          ? self.$store.getters.filter_topic
          : [{ id: "all", text: "Pilih Topik Media Online" }];
        // Sosial
        self.selectedTopic_sna = self.$store.getters.filter_topic_sna
          ? self.$store.getters.filter_topic_sna
          : [{ id: "all", text: "Pilih Topik Media Sosial" }];
        const id_selected = atob(self.$route.query.topic_selected).split(",");
        let topic_selected_medsos = [];
        let topic_selected_medkon = [];
        for (let i = 0; i < id_selected.length; i++) {
          // check medsos
          const t_medsos = topik.find((el) => el.id == id_selected[i]);
          if (t_medsos) {
            topic_selected_medsos.push(t_medsos);
          }
          // check medkon
          const t_medkon = topik_formed.find((el) => el.id == id_selected[i]);
          if (t_medkon) {
            topic_selected_medkon.push(t_medkon);
          }
        }
        // const selected_topic = [
        //   ...topic_selected_medkon,
        //   ...topic_selected_medsos,
        // ];

        // Is Type Condtion
        if (self.isType || self.hideTopik) {
          self.selectedTopic_sna = [{ id: "all", text: "Pilih Topik Medaa Sosial" }];
          self.selectedTopic = [{ id: "all", text: "Pilih Topik Media Online" }];
        } else {
          self.selectedTopic = topic_selected_medkon
            ? topic_selected_medkon
            : [{ id: "all", text: "Pilih Topik Media Online" }];
          self.selectedTopic_sna = topic_selected_medsos
            ? topic_selected_medsos
            : [{ id: "all", text: "Pilih Topik Medaa Sosial" }];
        }
      } else {
        // Group
        self.selectedGroup = self.$store.getters.filter_group
          ? self.$store.getters.filter_group
          : { id: "all", text: "Semua Grup" };

        // is Type condition
        if (self.isType || self.hideTopik) {
          self.selectedTopic_sna = [{ id: "all", text: "Pilih Topik Media Sosial" }];
          self.selectedTopic = [{ id: "all", text: "Pilih Topik Media Online" }];
        } else {
          // Online
          self.selectedTopic = self.$store.getters.filter_topic
            ? self.$store.getters.filter_topic
            : [{ id: "all", text: "Pilih Topik Media Online" }];
          // Social
          self.selectedTopic_sna = self.$store.getters.filter_topic_sna
            ? self.$store.getters.filter_topic_sna
            : [{ id: "all", text: "Pilih Topik Media Sosial" }];
        }
      }
      let topic_opt = [];
      if (option.length > 0) {
        topic_opt = option;
      }
      topic_opt.unshift({
        text: "Pilih Topik Media Online",
        children: [
          {
            id: "all",
            text: "Semua Topik",
          },
        ],
      });

      if (topik.length > 0) {
        topic_opt.push({
          text: "Media Sosial",
          children: topik.filter((el) => el.tipe === "topik"),
          element: HTMLOptGroupElement,
        });
      }
      topic_opt.forEach((el) => {
        el.children.sort((a, b) => a.text.localeCompare(b.text));
      });
      const sliced_topic_options = topic_opt
        .slice(1)
        .sort((a, b) => a.text.localeCompare(b.text));

      self.initial_topic_options = [topic_opt[0], ...sliced_topic_options];
      self.topic_options = self.initial_topic_options;
      self.topic_temp_opt = self.topic_options;

      self.initial_topic_options_sna = [topic_opt[0], ...sliced_topic_options];
      self.topic_options_sna = self.initial_topic_options_sna;
      self.topic_temp_opt_sna = self.topic_options_sna;

      let group_opt = [];
      group_opt[0] = {
        text: "Semua Grup",
        children: [
          {
            id: "all",
            text: "Semua Grup",
          },
        ],
      };
      if (topik_formed.length > 0) {
        group_opt.push({
          text: "Media Online",
          children: topik_formed.filter((el) => el.tipe === "group"),
          element: HTMLOptGroupElement,
        });
      }
      group_opt.forEach((el) => {
        el.children.sort((a, b) => a.text.localeCompare(b.text));
      });
      self.group_options = group_opt;
      self.groupChanged(false);

      // Add this block to filter the topic options based on the is_type parameter
      self.topic_options_sna = self.topic_options.filter(option =>
        option.children.some(child => child.category === "medon")
      );
      // } else if (isType === "medkon") {
      self.topic_options = self.topic_options.filter(option =>
        option.children.some(child => child.category === "medkon")
      );

      // console.log(self.selectedTopic, self.selectedTopic_sna);

      self.$store.dispatch("set_topic_filter", self.selectedTopic);
      self.$store.dispatch("set_topic_filter_sna", self.selectedTopic_sna);
      self.$store.dispatch("set_group_filter", self.selectedGroup);

      return [self.selectedTopic, self.selectedGroup, self.selectedTopic_sna];
    },
    changeTopic: function (value) {
      // NOTE not use method
      if (value.id == "all") {
        this.deleteParam("topic");
      } else {
        if (value.id in this.topics.formed) {
          let queries = this.$route.query;
          delete queries.topic;
          this.updateUrlQuery("group", value.id);
        } else {
          let queries = this.$route.query;
          delete queries.group;
          this.updateUrlQuery("topic", value.id);
        }
      }

      this.$store.dispatch("set_topic_filter", value);
      let data = {
        from: this.start,
        to: this.end,
        topic: this.selectedTopic.id,
      };
      this.$emit("filterChange", data);
    },
    changeValidate: function () {
      if (this.is_validated == "Semua Data") {
        this.deleteParam("is_validated");
        let data = {
          from: this.start,
          to: this.end,
          topic: this.selectedTopic.id,
        };
        this.$store.dispatch("set_validate_filter", "Semua Data");
        this.$emit("filterChange", data);
      } else {
        this.deleteParam("is_validated");
        this.updateUrlQuery(
          "is_validated",
          this.is_validated == "Tervalidasi" ? 1 : 0
        );
        let data = {
          from: this.start,
          to: this.end,
          topic: this.selectedTopic.id,
          is_validated: this.is_validated == "Tervalidasi" ? 1 : 0,
        };
        this.$store.dispatch("set_validate_filter", this.is_validated);
        this.$emit("filterChange", data);
      }
    },
    changeCakupan: function () {
      if (this.cakupan == "Semua Cakupan") {
        this.deleteParam("cakupan");
        let data = {
          from: this.start,
          to: this.end,
          topic: this.selectedTopic.id,
        };
        this.$store.dispatch("set_cakupan_filter", this.cakupan);
        this.$emit("filterChange", data);
      } else {
        this.deleteParam("cakupan");
        this.updateUrlQuery("cakupan", this.cakupan.toLowerCase());
        let data = {
          from: this.start,
          to: this.end,
          topic: this.selectedTopic.id,
          cakupan: this.cakupan.toLowerCase(),
        };
        this.$store.dispatch("set_cakupan_filter", this.cakupan);
        this.$emit("filterChange", data);
      }
    },
    deleteParam: function (key) {
      let queries = this.$route.query;
      if (key == "topic_selected") {
        delete queries.topic_selected;
        delete queries.group;
      } else if (key == "is_validated") {
        delete queries.is_validated;
      } else if (key == "group") {
        delete queries.group;
      } else if (key == "cakupan") {
        delete queries.cakupan;
      }
      let self = this;
      let current_path = this.$route.path;
      this.$router
        .replace(current_path)
        .then(self.$router.replace({ query: queries }));
    },
    goBack: function () {
      this.$router.go(-1);
    },
    initLoadFilter: function () {
      // load filter validate
      if (!this.hideValidate) {
        if ("is_validated" in this.$route.query) {
          this.is_validated =
            this.$route.query.is_validated == 1
              ? "Tervalidasi"
              : "Belum Tervalidasi";
          this.updateUrlQuery(
            "is_validated",
            this.is_validated == "Tervalidasi" ? 1 : 0
          );
        } else {
          if (this.$store.getters.filter_validate) {
            this.is_validated = this.$store.getters.filter_validate;
            if (this.is_validated != "Semua Data") {
              this.updateUrlQuery(
                "is_validated",
                this.is_validated == "Tervalidasi" ? 1 : 0
              );
            }
          } else {
            this.is_validated = "Semua Data";
          }
        }
      }
      // load filter cakupan
      if (!this.hideCakupan) {
        if ("cakupan" in this.$route.query) {
          this.cakupan = this.$route.query.cakupan;
          this.updateUrlQuery("cakupan", this.cakupan.toLowerCase());
        } else {
          if (this.$store.getters.filter_cakupan) {
            this.cakupan = this.$store.getters.filter_cakupan;
            if (this.cakupan != "Semua Cakupan") {
              this.updateUrlQuery("cakupan", this.cakupan.toLowerCase());
            }
          } else {
            this.cakupan = "Semua Cakupan";
          }
        }
      }
      let date_param = this.loadFilter();
      let topic_param = this.loadTopic(this.isType);

      let data = {
        from: date_param.from,
        to: date_param.to,
      };
      // assign filter topic
      if (Array.isArray(topic_param[0]) || Array.isArray(topic_param[2])) {
        // Online
        let temp1 = Array.isArray(topic_param[0]) ? topic_param[0] : [];
        // Sosial
        let temp2 = Array.isArray(topic_param[2]) ? topic_param[2] : [];
        // combine
        let dataCombine = [...temp1, ...temp2];
        const hasAll = dataCombine.some(el => el.id === "all");
        const filteredData = hasAll ? dataCombine.filter(el => el.id !== "all") : dataCombine;
        // renew
        let temp = filteredData.map((el) => el.id);
        const id_selected = temp.join(",");
        if (id_selected != "") {
          data.topic_selected = btoa(id_selected);
        }
      } else {
        if (topic_param[0].id != "all" && topic_param[2].id != "all") {
          data.topic_selected = btoa(topic_param[0].id);
        }
      }
      // assign filter group
      if (Array.isArray(topic_param[1])) {
        if (topic_param[1][0].id != "all") {
          data.group = topic_param[1][0].id;
        }
      } else {
        if (topic_param[1].id != "all") {
          data.group = topic_param[1].id;
        }
      }
      // assign filter validated
      if (this.is_validated !== "Semua Data") {
        data.is_validated = this.is_validated == "Tervalidasi" ? 1 : 0;
      }
      // assign filter cakupan
      if (this.cakupan !== "Semua Cakupan") {
        data.cakupan = this.cakupan.toLowerCase();
      }
      this.updateUrlQueryMany(data);
    },
  },
  watch: {
    selectedTopic() {
      if (this.selectedTopic.length == 0) {
        this.selectedTopic = [{ id: "all", text: "Pilih Topik Media Online" }];
        this.changeSelectedTopic();
      }
    },
    selectedTopic_sna() {
      if (this.selectedTopic_sna.length == 0) {
        this.selectedTopic_sna = [{ id: "all", text: "Pilih Topik Media Sosial" }];
        this.changeSelectedTopic();
      }
    }
  },
  mounted() {
    if (!this.hideFilter) {
      this.initLoadFilter();
    }
    this.$emit("pageHeaderLoaded");
  },
};
</script>

<style scoped>
@import "~bootstrap-daterangepicker/daterangepicker.css";
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
#page-header-validasi {
  font-size: 14px !important;
}

.multiselect__tag {
  font-size: 14px !important;
  margin-right: 5px !important;
  background-color: #f16528 !important;
}

.multiselect__tag-icon:hover {
  background-color: #b52828 !important;
}

.multiselect__tags {
  border: 0 !important;
  box-shadow: rgba(184, 192, 202, 0.5) 0px 0px 3px !important;
}

.multiselect__strong {
  font-size: 12px !important;
}

.multiselect__content-wrapper {
  position: fixed !important;
  width: max-content !important;
  min-width: 300px !important;
  border: 1px solid rgba(184, 192, 202, 0.5) !important;
}

.multiselect__single {
  font-size: 14px !important;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}


.multiselect__option--group {
  background-color: #def8e5 !important;
  color: black !important;
}
</style>
